import { IconButton } from "@mui/material";
import Iconify from "../../../minimals/components/iconify";

const RemovalRequestPendingIconButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton onClick={onClick}>
      <Iconify icon="fluent-mdl2:remove-from-trash" width={24} />
    </IconButton>
  );
};

export default RemovalRequestPendingIconButton;
